import { combineReducers } from 'redux';
import configStore from './config';
import agentsStore from './agents';
import paymentStore from './payment';
import careersStore from './careers';
import questionsStore from './questions';
import newsletterStore from './newsletter';

export default combineReducers({
  configStore,
  agentsStore,
  paymentStore,
  careersStore,
  questionsStore,
  newsletterStore
});
